import { AxiosInstance } from 'axios'
import { useQuery } from 'react-query'

import { BasicUser } from '@dc-shared-web/hooks/api/user'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

type GetUserQueryParams = {
  userId?: string | null
}

const fetchUserById = async (
  apiClient: AxiosInstance,
  params?: GetUserQueryParams
): Promise<BasicUser> => {
  const res = await apiClient.get(`/api/users/${params?.userId}`)
  return res.data.data
}

export const useGetUserById = (params?: GetUserQueryParams) => {
  const apiClient = useAxiosContext()

  return useQuery(
    `user-${params?.userId}`,
    () => fetchUserById(apiClient, params),
    {
      enabled: !!params?.userId,
    }
  )
}
